import { render } from "./staticcode.vue?vue&type=template&id=4e151db8"
import script from "./staticcode.vue?vue&type=script&lang=js"
export * from "./staticcode.vue?vue&type=script&lang=js"

import "./staticcode.vue?vue&type=style&index=0&id=4e151db8&lang=css"

import exportComponent from "D:\\work\\sckj\\wwei\\ww-vue\\wwei_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__